import { Trans } from "@lingui/react/macro";
import { useId } from "react";

import { Switch } from "@/shared/ui/switch";

type VisibilitySectionProps = {
  visible: boolean;
  pending: boolean;
  onChange: (visible: boolean) => void;
};

// «Показывать меня друзьям»: выключил — пропал из их таблиц, а их таблица скрылась у тебя.
export const VisibilitySection = ({ visible, pending, onChange }: VisibilitySectionProps) => {
  const headingId = useId();
  const descriptionId = useId();
  return (
    <section
      aria-labelledby={headingId}
      className="flex flex-wrap items-center justify-between gap-x-6 gap-y-3 rounded-xl border border-border bg-surface px-5 py-4"
    >
      <div className="flex flex-[1_1_420px] flex-col gap-0.5">
        <h2 id={headingId} className="text-[17px] font-semibold">
          <Trans>Show me to friends</Trans>
        </h2>
        <p id={descriptionId} className="text-sm text-muted">
          <Trans>
            Friends on Relock see your place, scores and heroes. Turn it off and you disappear from
            their tables, and their table is hidden from you too.
          </Trans>
        </p>
      </div>
      <span className="flex min-h-11 items-center">
        <Switch
          checked={visible}
          disabled={pending}
          onCheckedChange={onChange}
          aria-labelledby={headingId}
          aria-describedby={descriptionId}
        />
      </span>
    </section>
  );
};
